import { render, staticRenderFns } from "./tabTableList.vue?vue&type=template&id=0fa944ec&scoped=true&"
import script from "./tabTableList.vue?vue&type=script&lang=js&"
export * from "./tabTableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa944ec",
  null
  
)

export default component.exports